import { type ProductOfferStatus } from '@/modules/product/aliases';
import { OfferStatus } from '@/modules/product/types';

export const INACTIVE_OFFER_STATES: ProductOfferStatus[] = [
  OfferStatus.UNAVAILABLE,
  OfferStatus.EXPIRED,
  OfferStatus.REJECTED,
  OfferStatus.RESCINDED,
];

export const COUNTER_OFFER_TRANSLATION_KEYS: Record<string, string> = {
  PRODUCT_UNAVAILABLE: 'Error.Counter.PRODUCT_UNAVAILABLE',
  USER_ERROR: 'Error.USER_ERROR',
  OFFER_LOWER_THAN_PREVIOUS: 'Error.OFFER_LOWER_THAN_PREVIOUS',
  OFFER_HIGHER_THAN_CURRENT_OFFER:
    'Error.Counter.OFFER_HIGHER_THAN_CURRENT_OFFER',
  OFFER_BELOW_FLOOR_PRICE: 'Error.OFFER_BELOW_FLOOR_PRICE',
  EXISTING_OFFER_SENT: 'Error.EXISTING_OFFER_SENT',
};

export const OFFER_ERROR_TRANSLATION_KEYS = [
  'PRODUCT_UNAVAILABLE',
  'Counter.PRODUCT_UNAVAILABLE',
  'PRODUCT_BANNED',
  'PRODUCT_SOLD',
  'OFFERER_BANNED',
  'OFFER_EXPIRED',
  'OFFER_LOWER_THAN_PREVIOUS',
  'EXISTING_OFFER_SENT',
  'USER_ERROR',
  'OFFER_TOO_LOW',
  'OFFER_TOO_HIGH',
  'OFFER_HIGHER_THAN_CURRENT_OFFER',
  'Counter.OFFER_HIGHER_THAN_CURRENT_OFFER',
  'OFFER_BELOW_FLOOR_PRICE',
  'OFFER_ABOVE_CEILING_PRICE',
  'RequestFailed',
];
